import React, { useEffect, useRef, useState } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import './TextEditor.css';
import { setContaint, getContaint } from './ArticleContent';
import mediaApi from "./mediaApi"

// Explicitly import and register code-block and blockquote formats
const CodeBlock = Quill.import("formats/code-block");
const Blockquote = Quill.import("formats/blockquote");
const ImageBlot = Quill.import('formats/image');

CodeBlock.tagName = "code"; 
ImageBlot.className = 'custom-image';
Quill.register(ImageBlot, true);
Quill.register(CodeBlock, true);

const TextEditor = () => {
  const editorRef = useRef(null);
  const quillRef = useRef(null);
  const [content, setContent] = useState("");

  useEffect(() => {
    if (!editorRef.current || quillRef.current) return;

    if (getContaint()) setContent(getContaint());

    const quill = new Quill(editorRef.current, {
      theme: "snow",
      placeholder: "Start writing your article...",
      modules: {
        toolbar: {
          container: [
            [{ header: [1, 2, 3, 4, 5, 6, false, "span"] }],
            [{ font: [] }],
            ["bold", "italic", "underline", "strike", "code-block"],
            [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
            ["code-block", "blockquote"],
            ["link", "image"],
            ["clean"],
          ],
          handlers: {
            image: imageHandler, // 👈 custom handler
          },
        },
      },
      formats: [
        "header", "font", "size", "bold", "italic", "underline", "strike",
        "list", "bullet", "indent", "link", "image", "color", "background",
        "code-block", "blockquote"
      ],
    });

    quillRef.current = quill;

    const handleTextChange = () => {
      const html = quill.root.innerHTML;
      setContaint(html);
      console.log("Quill Content Changed:", html);
      setContent(html);
    };

    quill.on("text-change", handleTextChange);

    return () => {
      quill.off("text-change", handleTextChange);
    };
  }, []);

  // ✅ Simple custom image upload handler
  const imageHandler = async () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("file", file);

      try {
        // 🔥 replace this with your actual API endpoint
        const imageUrl = await mediaApi.post("/media/upload", formData);
        const range = quillRef.current.getSelection(true);
quillRef.current.insertEmbed(range.index, 'image', imageUrl, 'user');
quillRef.current.setSelection(range.index + 1);

      } catch (error) {
        console.error("Image upload failed:", error);
      }
    };
  };

  return (
    <div>
      <div ref={editorRef} style={{ height: "400px" }} />
      <p>Content Preview:</p>
      <div
        dangerouslySetInnerHTML={{ __html: content }}
        style={{ border: "1px solid #ccc", padding: "10px" }}
      />
    </div>
  );
};

export default TextEditor;
